import React, { useState, useEffect } from 'react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { CheckCircle } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const PaymentSuccess = () => {
  const [status, setStatus] = useState('checking');
  const [paymentDetails, setPaymentDetails] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session_id');
    
    if (sessionId) {
      checkPaymentStatus(sessionId);
    } else {
      setStatus('error');
    }
  }, []);

  const checkPaymentStatus = async (sessionId) => {
    try {
      const response = await axios.get(`${API}/payment/status/${sessionId}`);
      setPaymentDetails(response.data);
      setStatus(response.data.status);
    } catch (error) {
      console.error('Payment status check failed:', error);
      setStatus('error');
    }
  };

  if (status === 'checking') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
        <Card className="p-8 max-w-md text-center">
          <div className="spinner mx-auto mb-4"></div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Verifying Payment</h2>
          <p className="text-gray-600">Please wait while we confirm your payment...</p>
        </Card>
      </div>
    );
  }

  if (status === 'paid') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 flex items-center justify-center">
        <Card className="p-8 max-w-lg text-center">
          <CheckCircle className="h-16 w-16 text-green-600 mx-auto mb-6" />
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Payment Successful!</h1>
          <p className="text-gray-600 mb-6">
            Thank you for your purchase. Your credits have been added to your account.
          </p>
          {paymentDetails && (
            <div className="bg-green-50 p-4 rounded-lg mb-6">
              <div className="text-sm text-gray-700">
                <div>Credits Added: <span className="font-semibold">{paymentDetails.credits_added}</span></div>
                <div>Amount Paid: <span className="font-semibold">${paymentDetails.amount}</span></div>
              </div>
            </div>
          )}
          <div className="space-x-4">
            <Button onClick={() => window.location.href = '/recommendations'}>
              View Recommendations
            </Button>
            <Button variant="outline" onClick={() => window.location.href = '/roi-simulator'}>
              Try ROI Simulator
            </Button>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-pink-50 to-rose-50 flex items-center justify-center">
      <Card className="p-8 max-w-md text-center">
        <div className="text-red-600 mb-4">
          <div className="h-16 w-16 mx-auto bg-red-100 rounded-full flex items-center justify-center">
            <span className="text-2xl">❌</span>
          </div>
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-4">Payment Issue</h2>
        <p className="text-gray-600 mb-6">
          There was an issue processing your payment. Please try again or contact support.
        </p>
        <Button onClick={() => window.location.href = '/pricing'}>
          Try Again
        </Button>
      </Card>
    </div>
  );
};

export default PaymentSuccess;
